import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  root: {
    position: 'absolute',
    zIndex: 1000,
    color: '#1f8ef1',
  },
}));
